import React, { useEffect } from "react";

const TSPayCompletedConsents = () => {
  useEffect(() => {
    if (window && window.opener) {
      window.opener.postMessage({
        consentCompleted: window.location.href.split("/")[
          window.location.href.split("/").length - 1
        ]
      },
      "*");
      window.close();
    }
  }, []);

  return <React.Fragment></React.Fragment>;
};

export default TSPayCompletedConsents;
